<template>
    <b-container fluid class="img-bg">
        <b-row no-gutters>
            <b-col sm class="header-column">
                <AdminBar ref="titlebar" title="Napoli Sotterranea Virtual Tour" @languageChanged="updateLang"></AdminBar>
            </b-col>
        </b-row>
        <b-row no-gutters class="mainrow">
            <b-col xl="1" class="d-none d-xl-block">
            </b-col>
            <b-col xl="7" lg="8" md="12" >
                <div class="panel tourbox">
                    <Calendar ref="calendar_view" :locale="active_language" @event-click="selectEvent"></Calendar>
                </div>
            </b-col>
            <b-col xl="3" lg="4" md="12">
                <div class="panel eventcard">
                    <EventCard :tour_prop="selected_tour" @buy="buyticket" :lang="active_language"></EventCard>
                </div>
                <div class="panel eventcard">
                    <StripeCard ref="stripecart" @purchase-success="confirmTicket" @purchase-failed="retireTicket" :lang="active_language"></StripeCard>
                </div>
            </b-col>
            <b-col xl="1" class="d-none d-xl-block">
            </b-col>
        </b-row>

        <b-modal
                id="modal-prevent-closing"
                ref="modal"
                title="Compila con nome ed email per proseguire con l'acquisto"
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close
                @show="resetModal"
                @hidden="resetModal"
                @ok="handleOk"
        >
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                        :state="nameState"
                        invalid-feedback="Inserisci il nome"
                >
                    <b-input-group>
                        <b-input-group-text><b-icon-person></b-icon-person></b-input-group-text>
                        <b-form-input
                                v-model="name"
                                :state="nameState"
                                type="text"
                                placeholder="Nome"
                                required
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>

                <b-form-group
                        :state="mailState"
                        invalid-feedback="Inserisci l'email"
                >
                    <b-input-group>
                        <b-input-group-text><b-icon-at></b-icon-at></b-input-group-text>
                        <b-form-input
                                v-model="mail"
                                :state="mailState"
                                type="email"
                                placeholder="Email"
                                required
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>

                <h6>Se hai già acquistato un coupon inseriscilo qui</h6>
                <b-form-group :state="couponState" invalid-feedback="Coupon non valido">
                    <b-input-group>
                        <b-input-group-text><b-icon-tag></b-icon-tag></b-input-group-text>
                        <b-form-input
                                v-model="coupon"
                                :state="couponState"
                                type="text"
                                placeholder="Codice"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </form>
        </b-modal>

    </b-container>
</template>

<script>
    import moment from "moment";
    moment.locale('IT');

    import EventCard from "./EventCard";
    import AdminBar from "./AdminBar";
    import StripeCard from "./StripeCard"
    import Calendar from "./Calendar";

    export default {
        name: "Home",
        components: {
            EventCard,
            AdminBar,
            StripeCard,
            Calendar
        },
        data () {
            return {
                active_language: 'IT',
                selected_tour: null,
                unsubscribe_listener: null,
                name: '',
                mail: '',
                coupon: '',
                couponState: null,
                nameState: null,
                mailState: null,
                localized_text:{
                    IT:{buy:'Acquista', modalHeader:'Compila con nome ed email per proseguire con l\'acquisto'},
                    EN:{buy:'Buy'}
                }
            }
        },
        methods: {
            checkFormValidity: async function() {
                const valid = this.$refs.form.checkValidity();

                console.log(valid);

                this.nameState = valid;
                this.mailState = valid;
                this.couponState = true;

                if(this.coupon.trim().length){
                    let isTicketValid = this.$firebase.functions.httpsCallable('isTicketValid');

                    console.log('start');

                    try {
                        let asd = await isTicketValid({ticket: this.coupon, email: null});
                        console.log(asd);
                        this.couponState = true;
                    }
                    catch {
                        this.couponState = false;
                    }

                    console.log('end');

                    /*isTicketValid({ticket: this.coupon, email: null}).then(function() {
                        this.couponState = true;
                    }.bind(this)).catch(function() {
                        // console.log("Error getting document:", error);
                        this.couponState = false;
                    }.bind(this))*/
                }
                return (valid && this.couponState);
            },
            resetModal() {
                this.name = '';
                this.mail = '';
                this.coupon = '';
                this.nameState = null;
                this.mailState = null;
                this.couponState= null;
            },
            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault();
                // Trigger submit handler
                this.handleSubmit();
            },
            handleSubmit() {
                // Exit when the form isn't valid
                this.checkFormValidity().then((valid) => {
                    if(!valid) {
                        console.log('WTF');
                    } else {

                        let ticket = {
                            valid: true,
                            used: false,
                            event_id: this.selected_tour.id,
                            user_name: this.name,
                            user_email: this.mail,
                            time_of_event: this.selected_tour.start,
                            purchased: Date.now()
                        }

                        this.$firebase.ticketsCollection.add(ticket)
                            .then(function() {
                                this.$firebase.eventsCollection.doc(this.selected_tour.id).update({
                                    "data.available_seats" : this.selected_tour.available_seats - 1
                                })
                                    .then(function() {
                                        console.log("Seat number successfully updated!");
                                        this.selected_tour = null;
                                    }.bind(this))
                                    .catch(function(error) {
                                        // The document probably doesn't exist.
                                        console.error("Error updating available seats: ", error);
                                    });

                            }.bind(this))
                            .catch(function(error) {
                                console.error("Error adding ticket: ", error);
                            });

                        // Hide the modal manually
                        this.$nextTick(() => {
                            this.$bvModal.hide('modal-prevent-closing')
                        })
                    }
                })
            },
            updateLang: function (_lang) {
                console.log(_lang);
                this.unsubscribe_listener();
                this.active_language = _lang;
                this.selected_tour = null;
                this.loadcalendar();
            },
            selectEvent: function(event) {
                this.selected_tour = event;
            },
            buyticket : function (){
                // this.$refs['modal'].show();
                this.$refs.stripecart.setCart({id:this.selected_tour.id, tour:this.selected_tour.tour,
                    time:new moment(this.selected_tour.start).format('LLL')});
            },
            loadcalendar: function (){
                this.unsubscribe_listener = this.$firebase.eventsCollection.where("tour.Language", "==",
                    this.active_language).onSnapshot( function(querySnapshot) {
                    this.$refs.calendar_view.addEventsFromSnapshot(querySnapshot);
                }.bind(this));
            },
            confirmTicket: async function (_purchasedata){
                let createticket = this.$firebase.functions.httpsCallable('createTicket');
                await createticket({event_id: this.selected_tour.id, purchasedata: _purchasedata}).catch((error) => {
                    console.error("Error adding ticket: ", error);
                });

                let sendemail = this.$firebase.functions.httpsCallable('sendMail');
                await sendemail({purchasedata: _purchasedata}).then((info) => {
                    console.log(info);
                }).catch((error) => {
                    console.error("Error sending email: ", error);
                });

            },
            retireTicket: async function (_ticketref){
                let retireticket = this.$firebase.functions.httpsCallable('retireTicket');
                await retireticket({ticketref: _ticketref}).catch((error) => {
                    console.error("Error retiring ticket: ", error);
                });
            }
        },
        created() {
            this.$nextTick(() => {
                this.$firebase.auth.signInAnonymously().then(() => {
                    this.active_language = this.$refs.titlebar.getActiveLanguage();
                    this.loadcalendar();
                }).catch(function(error) {
                    // Handle Errors here.
                    let errorCode = error.code;
                    let errorMessage = error.message;
                    console.log(errorCode, errorMessage);
                });
            })
        },
        beforeDestroy() {
            this.unsubscribe_listener();
        }
    }
</script>

<style scoped>

    .header-column{
        margin-top:1.5%;
        margin-bottom:1.5%;
    }

    .img-bg{
        background-image: url("../../public/ns_bg.jpg");
        background-size: cover;
        background-position: center;
        padding:0;
        height:100%;
        overflow:auto;
    }

    .mainrow{
        min-height:85%;
        padding: 0 10px 0 10px;
    }

    .panel{
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .eventcard{
        min-height:20%;
    }

    .tourbox{
        border: 5px solid transparent;
        outline: 1px solid #000;
        outline-offset: -5px;
    }

    @media screen and (max-width: 992px) {
        .header-column{
            margin-top:0;
            margin-bottom:5px;
        }

        .mainrow{
            height:50%;
            padding:0;
        }

        /deep/ .card-header {
            font-size: 0.75em;
            padding: 0px;
        }

        /deep/ .card-header-pills {
            margin-right: 0;
            margin-left: 0;
        }
    }

</style>
